import {
  FETCH_CREATE_TEMPLATE_REQUEST,
  FETCH_CREATE_TEMPLATE_SUCCESS,
  FETCH_CREATE_TEMPLATE_FALUIRE,
} from './createTemplateTypes'

const initialState = {
  loading: false,
  createTemplate: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_CREATE_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_CREATE_TEMPLATE_SUCCESS : return {
      ...state,
      createTemplate: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_CREATE_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      createTemplate: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
